import { render, staticRenderFns } from "./OrdenCompraFormComponent.vue?vue&type=template&id=5b34b372&"
import script from "./OrdenCompraFormComponent.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports